import React, {useEffect, useState} from 'react'
import {FieldInput, FieldInputProps} from '../field-input'
import {Button, HStack, VStack} from '@chakra-ui/react'
import {AddIcon, MinusIcon} from '@chakra-ui/icons'
import {getIn, useFormikContext} from 'formik'

export const RepeatableField = ({name, disabled, componentType, label, handleChange}: FieldInputProps) => {
  const [count, setCount] = useState(1)
  const {values} = useFormikContext()
  const value = getIn(values, name)
  useEffect(() => {
    if (value?.length) {
      setCount(value.length)
    }
  }, [value])

  return (
    <VStack w="full">
      {Array.from({length: count}).map((_, i) => (
        <FieldInput disabled={disabled} handleChange={handleChange} label={`${label} ${i + 1}`} componentType={componentType} key={i} name={`${name}.${i}`} />
      ))}
      <HStack justifyContent="flex-end" w="full">
        {count > 1 && (
          <Button
            size="xs"
            isDisabled={disabled}
            colorScheme="red"
            variant={'ghost'}
            leftIcon={<MinusIcon />}
            onClick={() => {
              setCount(count - 1)
            }}>
            Remove
          </Button>
        )}
        <Button
          size="xs"
          colorScheme="blue"
          variant="ghost"
          isDisabled={disabled}
          leftIcon={<AddIcon />}
          onClick={() => {
            setCount(count + 1)
          }}>
          Add
        </Button>
      </HStack>
    </VStack>
  )
}
